import { Injectable } from '@angular/core';
import { AuthStore } from '../../../../app/@store';
import { BaseApiPickerImpl } from '../base.api-picker';
import { ServiceDocumentsApi } from './service-documents.api';
import { ServiceDocumentMockApi } from './service-documents.mock.api';

@Injectable({ providedIn: 'root' })
export class ServiceDocumentsPicker extends BaseApiPickerImpl<
  ServiceDocumentsApi | ServiceDocumentMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: ServiceDocumentsApi,
    protected mockApi: ServiceDocumentMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
